export const ADD_MEDIUM_REQUEST = 'ADD_MEDIUM_REQUEST'
export const ADD_MEDIUM_SUCCESS = 'ADD_MEDIUM_SUCCESS'
export const ADD_MEDIUM_FALIURE = 'ADD_MEDIUM_FALIURE'
